import { render } from "./CatigoryProduct.vue?vue&type=template&id=33422ac6&scoped=true"
import script from "./CatigoryProduct.vue?vue&type=script&lang=js"
export * from "./CatigoryProduct.vue?vue&type=script&lang=js"

import "./CatigoryProduct.vue?vue&type=style&index=0&id=33422ac6&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33422ac6"]])

export default __exports__